export default [{
	label: "Mentions légales",
	url: "/legal"
}, {
	label: "Conditions générales",
	url: "/terms"
}, {
	label: "Politique de confidentialité et cookies",
	url: "/confidentialite"
}];